import { useStyletron } from "baseui";
import { Block } from "baseui/block";
import { Button } from "baseui/button";
import { ListItem, ListItemLabel } from "baseui/list"
import { VscLink } from "react-icons/vsc";
import { BacnetObjectMappingConfiguration, BacnetObjectTypes } from "../../../services/mapping/bacnet";
import { AccessRoles, useHasRole } from "../../../hooks/useHasRole";
import { LoadingView } from "../../../components";
import { useGetObjectByIdQuery } from "../../../services/objects";
import { HierarchyObjectNavigation } from "../../../components/HierarchyNavigation";
import { useReprocessMappingsMutation } from "../../../services/mapping/bacnet/bacnetStateApi";
import { useReportMutationState } from "../../../hooks/useReportMutationState";
import { DeleteObjectMappingButton } from "../../Mapping/Bacnet/BacnetObjectMappingDeleteButton";

export const BacnetObjectMapppingListItem = (props: {item: BacnetObjectMappingConfiguration}) => {
    const hasAccessMappingWrite = useHasRole(AccessRoles.Mapping.Write);
    const { item } = props;
    const [css, theme] = useStyletron();

    const [reprocess, reprocessResult] = useReprocessMappingsMutation();
    const onReprocessMapping = () =>  reprocess({ edgeDeviceId: item.deviceId, deviceId: item.bACnetDeviceId, bacnetObjectType: item.objectMapping.type, bacnetInstanceId: item.objectMapping.instanceId });
    useReportMutationState(reprocessResult);

    return (<ListItem overrides={{
        ArtworkContainer: {
            style: ({ $theme }) => ({
                width: theme.sizing.scale1000
            })
        }
    }}
        artworkSize={'SMALL'} artwork={VscLink} key={item.id} endEnhancer={() =>
            <Block display='flex' flexDirection='column' gridGap='10px'>
                <Button disabled={!hasAccessMappingWrite} kind='secondary' size='compact' onClick={onReprocessMapping}>Reprocess Mapping</Button>
                <DeleteObjectMappingButton mappingId={item.id} name={item.id}></DeleteObjectMappingButton></Block>
        }>
        <ListItemLabel description={<DescriptionObject {...item}></DescriptionObject>}>
            {<HeaderObject {...item} />}</ListItemLabel>
    </ListItem>)
}

const HeaderObject = (props: BacnetObjectMappingConfiguration) => {
    return (
        <>
            <span>DeviceId: '{props.bACnetDeviceId}'</span><span> {BacnetObjectTypes[props.objectMapping.type]}:{props.objectMapping.instanceId}</span>
        </>
    );
}

const DescriptionObject = (props: BacnetObjectMappingConfiguration) => {

    const { data, isLoading, isSuccess, error } = useGetObjectByIdQuery({ resourceGroupId: props.resourceGroupId, id: props.objectId })
    return (
        <>
            <LoadingView isLoading={isLoading} isSucess={isSuccess} error={error}>
                {data &&
                    <HierarchyObjectNavigation resourceGroupId={props.resourceGroupId} objectId={props.objectId} currentAsLink={true} current={data.Name} currentDescription={data.description} showDescription={true}></HierarchyObjectNavigation>
                }
            </LoadingView>
        </>
    );
}